import React from 'react'
import LtsInputText from '../../../../components/lottus/lts-input-text'
import _ from 'lodash'
import { Button } from 'primereact/button'
import { icons } from '../../../../constants'
import { RadioButton } from 'primereact/radiobutton'
import LtsDropdownUnidade from '../../../../components/lottus/lts-dropdown-unidade'
import apiIdValueService from '../../../../services/api-id-value-service'

export const PbIndicadorForm = (props) => {
  return (
    <div style={{ marginTop: '20px' }}>
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <div className="p-grid form-group">
              <div className="p-col-12">
                <LtsInputText
                  value={_.get(props.record, 'nome', '')}
                  label={'Nome'}
                  onChange={(e) => props.setField('nome', e)}
                />
              </div>
            </div>
            <div className="p-grid form-group">
              <div className="p-col-12">
                <LtsInputText
                  value={_.get(props.record, 'cpf', '')}
                  label={'CPF'}
                  onChange={(e) => props.setField('cpf', e)}
                />
              </div>
            </div>
            <div className="p-grid form-group">
              <div className="p-col-12">
                <LtsInputText
                  value={_.get(props.record, 'telefone', '')}
                  label={'Telefone'}
                  onChange={(e) => props.setField('telefone', e)}
                />
              </div>
            </div>
            <div className="p-grid form-group">
              <div className="p-col-12">
                <LtsInputText
                  value={_.get(props.record, 'email', '')}
                  label={'E-mail'}
                  onChange={(e) => props.setField('email', e)}
                />
              </div>
            </div>
            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
                <label>Tipo Chave PIX</label>
                <RadioButton
                  id="rbtipoChavePixCPF"
                  value="CPF"
                  name="tipoPix"
                  onChange={(e) => props.setField('tipoChavePix', e.value)}
                  checked={_.get(props.record, 'tipoChavePix', '') === 'CPF'}
                  style={{ marginLeft: '10px', marginRight: '5px' }}
                />
                <label className="p-radiobutton-label" htmlFor="rbtipoChavePixCPF">
                  CPF
                </label>
                <RadioButton
                  id="rbtipoChavePixCNPJ"
                  value="CNPJ"
                  name="tipoPix"
                  onChange={(e) => props.setField('tipoChavePix', e.value)}
                  checked={_.get(props.record, 'tipoChavePix', '') === 'CNPJ'}
                  style={{ marginLeft: '10px', marginRight: '5px' }}
                />
                <label className="p-radiobutton-label" htmlFor="rbtipoChavePixCNPJ">
                  CNPJ
                </label>
                <RadioButton
                  id="rbtipoChavePixCelular"
                  value="CELULAR"
                  name="tipoPix"
                  onChange={(e) => props.setField('tipoChavePix', e.value)}
                  checked={_.get(props.record, 'tipoChavePix', '') === 'CELULAR'}
                  style={{ marginLeft: '10px', marginRight: '5px' }}
                />
                <label className="p-radiobutton-label" htmlFor="rbtipoChavePixCelular">
                  CELULAR
                </label>
                <RadioButton
                  id="rbtipoChavePixEmail"
                  value="EMAIL"
                  name="tipoPix"
                  onChange={(e) => props.setField('tipoChavePix', e.value)}
                  checked={_.get(props.record, 'tipoChavePix', '') === 'EMAIL'}
                  style={{ marginLeft: '10px', marginRight: '5px' }}
                />
                <label className="p-radiobutton-label" htmlFor="rbtipoChavePixEmail">
                  EMAIL
                </label>
                <RadioButton
                  id="rbtipoChavePixAleatoria"
                  value="ALEATORIA"
                  name="tipoPix"
                  onChange={(e) => props.setField('tipoChavePix', e.value)}
                  checked={_.get(props.record, 'tipoChavePix', '') === 'ALEATORIA'}
                  style={{ marginLeft: '10px', marginRight: '5px' }}
                />
                <label className="p-radiobutton-label" htmlFor="rbtipoChavePixAleatoria">
                  ALEATÓRIA
                </label>
              </div>
            </div>
            <div className="p-grid form-group">
              <div className="p-col-12">
                <LtsInputText
                  value={_.get(props.record, 'chavePix', '')}
                  label={'Chave PIX'}
                  onChange={(e) => props.setField('chavePix', e)}
                />
              </div>
            </div>
            <div className="p-grid form-group">
              <div className="p-col-12">
                <LtsDropdownUnidade
                  name={'unidade'}
                  label={'Unidade'}
                  value={props.record.unidade}
                  onChange={(e) => props.setField('unidade', e)}
                  showOptionAll={false}
                  loadDataFn={apiIdValueService.getPublicUnidades}
                />
              </div>
            </div>

            <div className="p-grid form-group">
              <div className="p-col-12">
                <Button
                  label={'Cadastrar Parceiro'}
                  onClick={() => {
                    props.onClickCadastrarIndicador()
                  }}
                  disabled={!props.canCadastrarIndicador()}
                  icon={icons.CHECK_ICON}
                  className="p-button-success"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
